import { compileRulesToGroupFields } from '../RulesBlock/RulesBlock.helpers';

import messages from './CustomerPreview.messages';

// Ported from classpass-mobile ios/.../DetailsForm/ModifierGroupFeature.swift @ a55cfe68

export const resolveSelectionsMax = (selectionsMax, optionCount) =>
  selectionsMax === 0 ? Math.max(optionCount, 1) : selectionsMax;

export const isRequiredGroup = selectionsMin => selectionsMin > 0;

export const selectorType = ({ allowsQuantities, selectionsMin, selectionsMax }) => {
  if (allowsQuantities) return 'quantity';
  if (selectionsMin > 0 && selectionsMax === 1) return 'radio';
  return 'checkbox';
};

export const visibleOptions = options =>
  [...options]
    .filter(option => option.enabled !== false)
    .sort((left, right) => (Number(left.ordinal) || 0) - (Number(right.ordinal) || 0));

export const instructionSummary = ({ selectionsMin, selectionsMax, optionCount, allowsQuantities }) => {
  if (selectionsMin === selectionsMax) {
    return { message: messages.chooseExact, values: { count: selectionsMax } };
  }

  const shouldShowMax = selectionsMax < optionCount || allowsQuantities;

  if (selectionsMin > 1 && shouldShowMax) {
    return { message: messages.chooseRange, values: { min: selectionsMin, max: selectionsMax } };
  }
  if (shouldShowMax) {
    return { message: messages.chooseUpTo, values: { count: selectionsMax } };
  }
  if (selectionsMin > 1) {
    return { message: messages.chooseAtLeast, values: { count: selectionsMin } };
  }

  return null;
};

const previewQuantityOptions = options =>
  options.map(option => ({
    ...option,
    isDisabled: !!option.soldOut,
    isSelected: false,
    quantity: 0,
  }));

const previewStandardOptions = (options, { selectionsMin, selectionsMax }) => {
  const isRadioGroup = selectionsMin > 0 && selectionsMax === 1;
  const defaults = options.filter(option => option.isDefault && !option.soldOut).slice(0, selectionsMax);
  const defaultIds = new Set(defaults.map(option => option.id));
  const capReached = !isRadioGroup && defaults.length >= selectionsMax;

  return options.map(option => {
    const isDefault = defaultIds.has(option.id);

    return {
      ...option,
      isDisabled: !!option.soldOut || (capReached && !isDefault),
      isSelected: !option.soldOut && isDefault,
      quantity: null,
    };
  });
};

export const previewOptionState = (options, groupFields) => {
  const visible = visibleOptions(options);
  const selectionsMax = resolveSelectionsMax(groupFields.selectionsMax, visible.length);

  if (groupFields.allowsQuantities) {
    return previewQuantityOptions(visible);
  }

  return previewStandardOptions(visible, {
    selectionsMin: groupFields.selectionsMin,
    selectionsMax,
  });
};

export const previewValuesFromRules = (rules, options) => {
  const visible = visibleOptions(options);
  const optionCount = visible.filter(option => (option.name || '').trim()).length;
  const groupFields = compileRulesToGroupFields(rules, optionCount);
  const selectionsMax = resolveSelectionsMax(groupFields.selectionsMax, optionCount);

  return {
    allowsQuantities: groupFields.allowsQuantities,
    instruction: instructionSummary({
      allowsQuantities: groupFields.allowsQuantities,
      optionCount,
      selectionsMax,
      selectionsMin: groupFields.selectionsMin,
    }),
    optionCount,
    previewOptions: previewOptionState(options, groupFields),
    selectionsMax,
    selectionsMin: groupFields.selectionsMin,
    selector: selectorType({
      allowsQuantities: groupFields.allowsQuantities,
      selectionsMax,
      selectionsMin: groupFields.selectionsMin,
    }),
  };
};
